import axios from 'axios';

axios.defaults.validateStatus = function (status) {
	// succeed on any 2xx response code except 204 no content
	// return (status >= 200 && status < 300) && status !== 204;
	return (status >= 200 && status < 300);
}